import {
  Component,
  Input,
  OnInit,
  OnChanges,
  SimpleChanges
} from '@angular/core';
import { Router } from '@angular/router';
import {
  CommissionSummary,
  STATISTICS_COMPUTATION_LABELS,
} from '@base/src/app/models/renditions/commission-summary.model';
import { Constants } from 'src/app/models/constants';
import { environment } from '@base/environments/environment';
import { AGENT_TYPE_PERCENTAGES } from '../agent-type-percentages';
import { QRChip } from '@base/src/app/models/qr-chip.model';

@Component({
  selector: 'app-commission-summary',
  templateUrl: './commission-summary.component.html',
  styleUrls: ['./commission-summary.component.scss']
})
export class CommissionSummaryComponent implements OnInit, OnChanges {
  @Input() data?: CommissionSummary;

  showSummaryAgentSeller = true;
  showRowSecondAnimation = true;

  sellerAgentShow = true;
  sellerReferredShow = true;
  sellerTeamLeaderShow = true;

  referidoACobrarShow = true;

  buyerAgentShow = true;
  buyerReferredShow = true;
  buyerTeamLeaderShow = true;

  officeShow = true;

  statisticsShow = true;

  statisticsModeChip: QRChip = {
    hierarchy: QRChip.HIERARCHY_2,
    size: QRChip.SIZE_SMALL,
    isCleanButtonVisible: false,
  };

  ivaShow = true;

  showRowSecond = true;

  isRendition = false;
  isCuota = false;
  isIngresoRelacionado = false;
  isReferidoACobrar = false;

  cobrokerUSD = 0;
  cobrokerLocal = 0;
  cobrokerInitVisualUSD = 0;
  cobrokerInitVisualLocal = 0;

  dataAgentTypes: Record<string, number> = AGENT_TYPE_PERCENTAGES;

  readonly NODE = environment.node;
  readonly NODE_AR = Constants.TENANT_ID_AR;
  readonly NODE_EC = Constants.TENANT_ID_EC;
  readonly NODE_PY = Constants.TENANT_ID_PY;
  readonly NODE_DO = Constants.TENANT_ID_DO;
  readonly NODE_GLOBAL = Constants.TENANT_ID_GLOBAL;

  cobrokerShow: boolean[] = [];

  cobrokerTeamLeaderShow: boolean[] = [];

  constructor(public router: Router) {}

  ngOnInit(): void {
    switch (true) {
      case this.router.url.includes('cuota'):
        this.isCuota = true;
        break;
      case this.router.url.includes('ingreso-relacionado'):
        this.isIngresoRelacionado = true;
        break;
      case this.router.url.includes('referido-a-cobrar'):
        this.isReferidoACobrar = true;
        break;
      default:
        this.isRendition = true;
        break;
    }
    if (this.NODE === this.NODE_DO) {
      this.cobrokerCalculation();
      this.initCobrokerFlags();
    }
  }

  cobrokerCalculation() {
    this.cobrokerInitVisualUSD =
      this.data?.cobrokers?.reduce((sum, cobroker) => {
        return (
          sum + cobroker.rawCommission.usd
          // (!cobroker.officeId && !cobroker.otherRealEstateName
          //   ? cobroker.rawCommission.usd
          //   : 0)
        );
      }, 0) ?? 0;
    this.cobrokerInitVisualLocal =
      this.data?.cobrokers?.reduce((sum, cobroker) => {
        return (
          sum + cobroker.rawCommission.local
          // (!cobroker.officeId && !cobroker.otherRealEstateName
          //   ? cobroker.rawCommission.local
          //   : 0)
        );
      }, 0) ?? 0;

    this.cobrokerUSD =
      this.data?.cobrokers?.reduce((sum, cobroker) => {
        return sum + cobroker.rawCommission.usd;
      }, 0) ?? 0;
    this.cobrokerLocal =
      this.data?.cobrokers?.reduce((sum, cobroker) => {
        return sum + cobroker.rawCommission.local;
      }, 0) ?? 0;
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['data'] && this.NODE === this.NODE_DO) {
      this.initCobrokerFlags();
      this.cobrokerCalculation();
    }
  }

  private initCobrokerFlags(): void {
    const cobrokersLength = this.data?.cobrokers?.length ?? 0;

    if (cobrokersLength === 0) {
      this.cobrokerShow = [];
      this.cobrokerTeamLeaderShow = [];
      return;
    }

    this.cobrokerShow = Array(cobrokersLength).fill(true);
    this.cobrokerTeamLeaderShow = Array(cobrokersLength).fill(true);
  }

  sellerAgentBox() {
    if (
      this.data?.seller.agent.name &&
      !this.data?.seller.officeId &&
      this.data.seller.agent.office
    ) {
      this.sellerAgentShow = !this.sellerAgentShow;
    }
  }

  sellerTeamLeaderBox() {
    if (
      this.data?.seller.teamLeader.name &&
      (this.data.seller.teamLeader.rawCommission.usd > 0 ||
        this.data.seller.teamLeader.rawCommission.local > 0)
    ) {
      this.sellerTeamLeaderShow = !this.sellerTeamLeaderShow;
    }
  }

  buyerTeamLeaderBox() {
    if (
      this.data?.buyer.teamLeader.name &&
      (this.data.buyer.teamLeader.rawCommission.usd > 0 ||
        this.data.buyer.teamLeader.rawCommission.local > 0)
    ) {
      this.buyerTeamLeaderShow = !this.buyerTeamLeaderShow;
    }
  }

  referidoACobrarBox() {
    this.referidoACobrarShow = !this.referidoACobrarShow;
  }

  buyerAgentBox() {
    if (
      this.data?.buyer.agent.name &&
      !this.data?.buyer.officeId &&
      this.data.buyer.agent.office
    ) {
      this.buyerAgentShow = !this.buyerAgentShow;
    }
  }

  sellerReferredBox() {
    if (
      this.data?.seller.referred.name &&
      !this.data?.seller.referred.officeId &&
      this.data.seller.agent.office
    ) {
      this.sellerReferredShow = !this.sellerReferredShow;
    }
  }

  buyerReferredBox() {
    if (
      this.data?.buyer.referred.name &&
      !this.data?.buyer.referred.officeId &&
      this.data.buyer.agent.office
    ) {
      this.buyerReferredShow = !this.buyerReferredShow;
    }
  }

  toggleCobrokerBox(index: number): void {
    const cobroker = this.data?.cobrokers?.[index];
    if (!cobroker) {
      return;
    }

    this.cobrokerShow[index] = !this.cobrokerShow[index];
  }

  toggleCobrokerTeamLeader(index: number): void {
    const cobroker = this.data?.cobrokers?.[index];
    if (!cobroker) {
      return;
    }

    if (
      cobroker.teamLeader?.name &&
      (cobroker.teamLeader.rawCommission.usd > 0 ||
        cobroker.teamLeader.rawCommission.local > 0)
    ) {
      this.cobrokerTeamLeaderShow[index] = !this.cobrokerTeamLeaderShow[index];
    }
  }

  get showStatistics(): boolean {
    return (
      this.NODE === this.NODE_DO &&
      (this.data?.statistics?.rows?.length ?? 0) > 0
    );
  }

  get statisticsModeLabel(): string {
    return STATISTICS_COMPUTATION_LABELS[this.data?.statistics?.mode ?? 1];
  }

  /** El signo va afuera del simbolo: "- U$S 590,4" */
  statisticsSign(value: number): string {
    return Math.round(value * 100) < 0 ? '- ' : '';
  }

  statisticsAbs(value: number): number {
    return Math.abs(value);
  }

  get showSplitBuyer(): boolean {
    const agentUsd = this.data?.buyer.agent.type.usd ?? 0;
    const agentLocal = this.data?.buyer.agent.type.local ?? 0;
    const tlUsd = this.data?.buyer.teamLeader.rawCommission.usd ?? 0;
    const tlLocal = this.data?.buyer.teamLeader.rawCommission.local ?? 0;

    if (this.NODE !== this.NODE_DO) {
      return tlUsd > 0 || tlLocal > 0;
    }

    return (
      agentUsd > 0 ||
      agentLocal > 0 ||
      (agentUsd === 0 && agentLocal === 0 && (tlUsd > 0 || tlLocal > 0))
    );
  }

  get showSplitSeller(): boolean {
    const agentUsd = this.data?.seller.agent.type.usd ?? 0;
    const agentLocal = this.data?.seller.agent.type.local ?? 0;
    const tlUsd = this.data?.seller.teamLeader.rawCommission.usd ?? 0;
    const tlLocal = this.data?.seller.teamLeader.rawCommission.local ?? 0;

    if (this.NODE !== this.NODE_DO) {
      return tlUsd > 0 || tlLocal > 0;
    }

    return (
      agentUsd > 0 ||
      agentLocal > 0 ||
      (agentUsd === 0 && agentLocal === 0 && (tlUsd > 0 || tlLocal > 0))
    );
  }
}
